import React from 'react'

const HelpShopify = () => {
  return (
    <>
      <h2>How to get Shopify API Key & Password for PixelOne</h2>
      <h4>Login into shopify store with Admin Access:</h4>
      <p>
        1) Goto <strong>Apps</strong> Click on
        <strong>Manage Private Apps</strong>
      </p>
      <p>
        2) Click on <strong>Create a new private app</strong>
      </p>
      <p>3) Use the following info the fill the form</p>
      <p>
        App Name: <strong>PixelOne</strong>
      </p>
      <p>
        Email: <strong>usman@pixelone.app</strong>
      </p>
      <br />
      <h4>Allow following API Permissions for Read & Write</h4>
      <p>
        <strong>Fulfillment services</strong> read_fulfillments,
        write_fulfillments
      </p>
      <p>
        <strong>Inventory</strong> read_inventory, write_inventory
      </p>
      <p>
        <strong>Products</strong> read_products, write_products
      </p>
      <p>
        <strong>Locations</strong> read_locations
      </p>
      <p>
        <strong>Order editing</strong> read_order_edits, write_order_edits
      </p>
      <p>
        <strong>Orders</strong> read_orders, write_orders
      </p>
      <p>
        <strong>Product editing</strong> read_product_listings,
        write_product_listings
      </p>
      <p>
        <strong>Customers</strong> read_customers, write_customers
      </p>
      <p>
        <strong>Store listings</strong> content read_content, write_content
      </p>
    </>
  )
}

export default HelpShopify
